/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Summary_Bar_Rate_HelpInputs */

const en_options_metrics_summary_bar_rate_help = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose whether the reading rate bar in the Summary tab displays characters per second (CPS) or words per minute (WPM).`)
};

const fr_options_metrics_summary_bar_rate_help = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose whether the reading rate bar in the Summary tab displays characters per second (CPS) or words per minute (WPM).`)
};

const de_options_metrics_summary_bar_rate_help = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose whether the reading rate bar in the Summary tab displays characters per second (CPS) or words per minute (WPM).`)
};

const it_options_metrics_summary_bar_rate_help = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose whether the reading rate bar in the Summary tab displays characters per second (CPS) or words per minute (WPM).`)
};

const ru_options_metrics_summary_bar_rate_help = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose whether the reading rate bar in the Summary tab displays characters per second (CPS) or words per minute (WPM).`)
};

const es_options_metrics_summary_bar_rate_help = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose whether the reading rate bar in the Summary tab displays characters per second (CPS) or words per minute (WPM).`)
};

const zh_cn2_options_metrics_summary_bar_rate_help = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose whether the reading rate bar in the Summary tab displays characters per second (CPS) or words per minute (WPM).`)
};

const ja_options_metrics_summary_bar_rate_help = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose whether the reading rate bar in the Summary tab displays characters per second (CPS) or words per minute (WPM).`)
};

const hi_options_metrics_summary_bar_rate_help = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose whether the reading rate bar in the Summary tab displays characters per second (CPS) or words per minute (WPM).`)
};

const pt_pt2_options_metrics_summary_bar_rate_help = /** @type {(inputs: Options_Metrics_Summary_Bar_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose whether the reading rate bar in the Summary tab displays characters per second (CPS) or words per minute (WPM).`)
};

/**
* | output |
* | --- |
* | "Choose whether the reading rate bar in the Summary tab displays characters per second (CPS) or words per minute (WPM)." |
*
* @param {Options_Metrics_Summary_Bar_Rate_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_summary_bar_rate_help = /** @type {((inputs?: Options_Metrics_Summary_Bar_Rate_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Summary_Bar_Rate_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metrics_summary_bar_rate_help(inputs)
	if (locale === "de") return de_options_metrics_summary_bar_rate_help(inputs)
	if (locale === "it") return it_options_metrics_summary_bar_rate_help(inputs)
	if (locale === "ru") return ru_options_metrics_summary_bar_rate_help(inputs)
	if (locale === "es") return es_options_metrics_summary_bar_rate_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metrics_summary_bar_rate_help(inputs)
	if (locale === "ja") return ja_options_metrics_summary_bar_rate_help(inputs)
	if (locale === "hi") return hi_options_metrics_summary_bar_rate_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metrics_summary_bar_rate_help(inputs)
	return en_options_metrics_summary_bar_rate_help(inputs)
});